import Vue from 'vue';
import VueResource from 'vue-resource';
import { validationMixin, Vuelidate } from 'vuelidate';
import { required, between } from 'vuelidate/lib/validators';

Vue.use(VueResource);
Vue.use(Vuelidate);

import datePicker from '../../components/forms/component.date-picker.vue';
import ageSwitch from '../../components/forms/component.age-birthdate-input-switch.vue';
import Multiselect from 'vue-multiselect';
import {
    onlyNumbers,
    isAfterField,
    mustBeChecked,
    spouseAgeValidation,
    monthDate,
    convertDateByLang,
    numbersWithDashSlash,
    noAlphabets,
    checkAgent
} from '../../helper-functions/helper-functions';
import {
    createUpdateQuoteService,
    initializeFormFromStorage,
    checkExpiredAndTriggerValidation,
    getItemSessionStorage,
    removeKeySessionStorage
} from '../../helper-functions/services';

import { LoginModalMixin } from '../../section-specific/applications/mixins/loginModal';
import { QuoteFormMixin } from '../quote-form/';


const defs = {}; // form defaults

switch (window.globalLanguage.section) {
    case 'student':
        defs.arrivalInUSA = '0';
        defs.citizenshipCountry = ibJS.studentCitizenship ? ibJS.studentCitizenship : '';
        defs.homeCountry = ibJS.studentHomeCountry ? ibJS.studentHomeCountry : '';
        break;
    case 'opt':
        defs.studyCountry = 'USA';
        defs.coverageArea = '1';
        defs.citizenshipCountry = '2';
        defs.arrivalInUSA = '0';
        break;
    case 'j1Visa':
        // including these to pass fe validation
        defs.studyCountry = 'USA';
        defs.citizenshipCountry = '2';
        defs.coverageArea = '1';
        defs.arrivalInUSA = '0';
        break;
    default:
}
Vue.component('multiselect', Multiselect);
Vue.component('quote-form-student-medical', {
    components: {
        'date-picker': datePicker,
        'age-switch': ageSwitch
    },
    props: ['ss-criteria', 'is-results-page'],
    mixins: [LoginModalMixin, QuoteFormMixin],
    data: function () {
        return {
            form: {
                primaryAge: null,
                primaryBday: '',
                spouseAge: null,
                spouseBday: '',
                numChildren10_17: '',
                numChildrenUnder10: '',
                startDate: '',
                endDate: '',
                studyCountry: defs.studyCountry || '',
                residenceCountry:'',
                homeCountry: defs.homeCountry || '',
                citizenshipCountry: defs.citizenshipCountry || '',
                arrivalInUSA: defs.arrivalInUSA || '',
                arrivalTime: defs.arrivalTime || '',
                mailingState: '',
                physicalPresenceState: '',
                section: window.globalLanguage.section || '',
                showSpouseAge: false,
                showNumChildren: false,
                visaStatus:'',
                activity:'1',
                f1Insurance:'-1',
                j1Insurance:'-1',
                medicalRequired: 'true',
                priorInsurance:'-1',
                priorInsuranceExpiration:'-1',
                currentLang: window.globalLanguage.lang,
                schoolId: null
            },
            formSending: false,
            showAges: false,
            agesOpened: false,
            showPrimaryByAge: true,
            showPrimaryAgeSwitch: false,
            showPrimaryBdSwitch: false,
            showSpouseByAge: true,
            showCoverageArea: false,
            covAreaOpened: false,
            showHomeCountry: false,
            homeCountryOpened: false,
            coverageAreaInfo: ibJS.coverageAreaDefault,
            homeCountryInfo: ibJS.homeCountryDefault,
            showArrivalInUSA:false,
            arrivalInUSAOpened:false,
            showLocation:false,
            locationOpened:false,
            showPriorInsurance:false,
            priorInsuranceOpened:false,
            showStudyingIn:false,
            studyingInOpened:false,
            showStudyDestination:false,
            qResultsLang: window.qResultsLang || null,
            residenceCountryInfo: ibJS.residenceCountryDefault,
            priorInsuranceInfo:ibJS.priorInsuranceDefault,
            arrivalInUSAInfo:ibJS.arrivalInUSADefault,
            locationInfo:'',
            visaStatusInfo:'',
            showVisaStatus:false,
            visaStatusOpened: false,
            showMobileError:false,
            primaryMinorAge: false,
            spouseMinorAge: false,
            priMinWithKid: false,
            multiselectFocus: false,
            isLoading: true,
            triggerTimeout: null,
            studyDestinationLabel: '',
            mailingFullState: '',
            schoolNames: [],
            selectedSchool: null,
            canNotFindSchoolName: false,
            closeOnSelectSchool: true,
            studyDestinationLabel: ''
        }
    },
    validations: function () {
        var validations = {
            form: {
                startDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets
                },
                endDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    isAfterStartDate: isAfterField('startDate')
                },
                citizenshipCountry: {},
                primaryAge: {
                    required,
                    onlyNumbers
                },
                spouseAge: {
                    spouseAgeValidation
                },
                mailingState: {
                    required
                },
                studyCountry: {},
                homeCountry: {},
                medicareAttest: {},
                arrivalInUSA: {},
                arrivalTime: {},
                physicalPresenceState: {},
                numChildrenUnder10:{
                    between: typeof between === 'function' ? between(1,7) : null
                },
                numChildren10_17:{
                    between: typeof between === 'function' ? between(1,7) : null
                },
                visaStatus: {},
                activity: {},
                medicalRequired: {},
                f1Insurance: {},
                j1Insurance: {},
                priorInsurance: {},
                priorInsuranceExpiration: {},
                schoolId: {}
            }
        };

        // Student
        if (this.form.section === 'student') {
            // require by default
            validations.form.studyCountry.required = required;
            validations.form.homeCountry.required = required;
            validations.form.citizenshipCountry.required = required;
            if(this.form.studyCountry === 'USA'){
                validations.form.visaStatus.required = required;
                validations.form.arrivalTime.required = required;
            }
            if(this.form.visaStatus === 'F2'){
                validations.form.f1Insurance.onlyNumbers = onlyNumbers;
            }
            if (this.form.arrivalTime != '0' && this.form.arrivalTime != '') {
                validations.form.physicalPresenceState.required = required;
            }

        }

        // J1 Visa
        if (this.form.section === 'j1Visa') {
            // require by default
            validations.form.arrivalInUSA.required = required;
            validations.form.arrivalTime.required = required;
            validations.form.medicalRequired.required = required;
            validations.form.visaStatus.required = required;
            validations.form.activity.required = required;

            if (this.form.arrivalTime != '0' && this.form.arrivalTime != '') {
                validations.form.physicalPresenceState.required = required;
            }
            if(this.form.visaStatus === 'J2'){
                validations.form.j1Insurance.onlyNumbers = onlyNumbers;
            }
        }

        if (this.form.studyCountry === 'USA' && !this.canNotFindSchoolName && (this.form.section === 'j1Visa' || this.form.section === 'student') && window.ibJS.validateSchool) {
            validations.form.schoolId.required = required;
        } else if (window.ibJS.isResultsPage && this.form.studyCountry === 'USA' && !this.canNotFindSchoolName && (this.form.section === 'j1Visa' || this.form.section === 'student') && this.ssCriteria?.schoolId) {
            validations.form.schoolId.required = required;
        }

        if (this.form.studyCountry === 'USA' && this.form.section === 'j1Visa' && this.form.medicalRequired == 'false') {
            delete validations.form.schoolId.required;
        }

        // OPT
        if (this.form.section === 'opt') {
            // require by default
            validations.form.arrivalTime.required = required;

            if(this.form.arrivalTime != '' && this.form.arrivalTime != '0' ){
                validations.form.physicalPresenceState.required = required;
            }
            if(this.form.arrivalTime >= '8'){
                validations.form.priorInsurance.onlyNumbers = onlyNumbers;
                if(this.form.priorInsurance === '1'){
                    validations.form.priorInsuranceExpiration.onlyNumbers = onlyNumbers;
                }
            }
        }

        if(this.form.showSpouseAge && (this.form.visaStatus !== 'J2' && this.form.visaStatus !== 'F2')){
            validations.form.spouseAge.required = required;
            validations.form.spouseAge.onlyNumbers = onlyNumbers;
        }
        if(this.form.showNumChildren){
            validations.form.numChildrenUnder10.required = required;
            validations.form.numChildren10_17.required = required;
        }

        if(this.form.numChildrenUnder10 > 0 || this.form.numChildren10_17 > 0){
            if(validations.form.numChildren10_17) {
                delete validations.form.numChildren10_17.required;
                delete validations.form.numChildren10_17.between;
            }
            if(validations.form.numChildrenUnder10) {
                delete validations.form.numChildrenUnder10.required;
                delete validations.form.numChildrenUnder10.between;
            }
        }
        return validations;
    },
    watch: {
        ssCriteria: function (ssCriteria) {
            let zeroChildSelect = 0;

            for (let key in ssCriteria) {
                if (typeof this.form[key] !== 'undefined') {
                    this.form[key] = ssCriteria[key];
                    if((key === "numChildrenUnder10" || key === "numChildren10_17") && this.form[key] == 0) {
                        zeroChildSelect += 1;
                    }
                    if(key === 'visaStatus' && this.form[key]) {
                        this.visaStatusInfo = this.form[key];
                    }
                    if(key === 'mailingState' && this.form[key]) {
                        const $mailingState = document.querySelector('#MailingState option[value="' + this.form[key] + '"]');
                        // fix firefox innerText compatibility issue
                        if (this.form.section === 'student') {
                            this.locationInfo = $mailingState ? $mailingState.innerText ? $mailingState.innerText.trim() : $mailingState.textContent.trim() : '';
                        }
                    }

                    if(key === 'physicalPresenceState' && this.form[key]) {
                        const $physicalPresence = document.querySelector('#physicalPresence option[value="' + this.form[key] + '"]');
                        if (this.form.section === 'j1Visa') {
                            this.locationInfo = $physicalPresence ? $physicalPresence.innerText ? $physicalPresence.innerText.trim() : $physicalPresence.textContent.trim() : '';
                        }
                    }
                }
            }

            /* If user does not select child, reset option*/
            if(zeroChildSelect === 2) {
                this.form["numChildrenUnder10"] = "";
                this.form["numChildren10_17"] = "";
            }
            
            /* init study destination field display */
            this.getSchool(this.form.schoolId);

            this.agesOpened = true;
            this.covAreaOpened = true;
            this.homeCountryOpened = true;
            this.arrivalInUSAOpened = true;
            this.locationOpened = true;
            this.priorInsuranceOpened = true;
            this.studyingInOpened = true;
        },
        'form.studyCountry': function () {
            if(this.form.studyCountry !== 'USA' && (this.form.visaStatus == 'F1' || this.form.visaStatus == 'F2')) {
                this.form.visaStatus = '';
            }
        },
        selectedSchool: function () {
            this.form.schoolId = this.selectedSchool? this.selectedSchool.code || null : null;
    
            if(this.form.schoolId !== null) {
                // uncheck universtiy not listed mark
                this.canNotFindSchoolName = false;
            }
        },
        canNotFindSchoolName: function() {
            if(this.canNotFindSchoolName) {
                this.selectedSchool = null;
                this.form.schoolId = null;
                this.studyDestinationLabelFn();
            }
        },
        'form.medicalRequired': function() {
            this.form.schoolId = null;
            this.selectedSchool = '';
        },  
    },
    created: function() {
        var self = this;

        //Add Additionals for - Different plan same person - MyAccount re-purchase
        if(ibJS.travellerDetails && ibJS.travellerDetails.length > 1) {
            this.form.showSpouseAge = true;
            this.form.spouseAge = ibJS.travellerDetails[1].age;

            if(ibJS.travellerDetails.length > 2) {
                let numChildren10_17 = ibJS.travellerDetails.filter((item, index) => {
                    return item.age > 9;
                });
                let numChildrenUnder10 = ibJS.travellerDetails.filter((item, index) => {
                    return item.age < 10;
                });
                this.form.showNumChildren = true;
                this.form.numChildren10_17 = numChildren10_17.length ? numChildren10_17.length.toString() : '';
                this.form.numChildrenUnder10 = numChildrenUnder10.length ? numChildrenUnder10.length.toString() : '';                
            }
        }

        if(typeof(initializeFormFromStorage) == 'function') {
            initializeFormFromStorage.call(this, window.globalLanguage.sectionCriteriaKey, function () {
                self.agesOpened = true;
                self.covAreaOpened = true;
                self.homeCountryOpened = true;
                self.arrivalInUSAOpened = true;
                self.locationOpened = true;
                self.priorInsuranceOpened = true;
                self.studyingInOpened = true;
                self.visaStatusOpened = true;
                self.form.primaryBday = '';
                self.form.spouseBday = '';
                self.visaStatusInfo = self.form.visaStatus;
                self.getSchool(self.form.schoolId);
    
                if(self.form.studyCountry !== 'USA'){
                    self.showVisaStatus = true;
                }else{
                    self.showVisaStatus = false;
                }
    
                convertDateByLang(self.form, window.globalLanguage.lang);
            });    
        }

        if(this.form.mailingState) {
            const $mailingState = document.querySelector('#MailingState option[value="' + this.form.mailingState + '"]');
            // fix firefox innerText compatibility issue
            if (this.form.section === 'student') {
                this.locationInfo = $mailingState ? $mailingState.innerText ? $mailingState.innerText.trim() : $mailingState.textContent.trim() : '';
            } else if (this.form.section === 'j1Visa') {
                this.mailingFullState = $mailingState ? $mailingState.innerText ? $mailingState.innerText.trim() : $mailingState.textContent.trim() : '';
            }
        }
        
        if(this.form.physicalPresenceState) {
            const $physicalPresence = document.querySelector('#physicalPresence option[value="' + this.form.physicalPresenceState + '"]');
            if (this.form.section === 'j1Visa') {
                this.locationInfo = $physicalPresence ? $physicalPresence.innerText ? $physicalPresence.innerText.trim() : $physicalPresence.textContent.trim() : '';
            }
        }
        

        // auto fill Study Country when landing from school page
        let id = getItemSessionStorage('schoolLandingPageId');
        if(id) {
            this.getSchool(id);
            this.form.studyCountry = 'USA';
            removeKeySessionStorage('schoolLandingPageId');
        }
        
        checkExpiredAndTriggerValidation.call(this);

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showAges = false;
                self.showCoverageArea = false;
                self.showHomeCountry = false;
                self.showArrivalInUSA = false;
                self.showLocation = false;
                self.showPriorInsurance = false;
                self.showStudyingIn = false;
                self.showStudyDestination = false;
                self.showVisaStatus = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });

        if(this.form.homeCountry && (this.form.section == 'student' || this.form.section == 'studyAbroad')) {
            this.locationInfo = $("#HomeCountry option[value='" + this.form.homeCountry + "']:first").text();
        }

        // when coming form myAccount - see MYACCOUNT-117
        if(window.ibJS && window.ibJS.age) {
            self.form.primaryAge = window.ibJS.age;
            self.agesOpened = true;
        }
        if(window.ibJS && window.ibJS.citizenship) {
            self.form.citizenshipCountry = window.ibJS.citizenship;
        }
        if(window.ibJS && window.ibJS.malingAddressState) {
            self.form.mailingState  = window.ibJS.malingAddressState ;
        }

        // set message if expiredDate is set to true by submitting the form on creation
        try {            
            if(window.sessionStorage?.getItem('expiredDate') == 'true'){
                window.sessionStorage.removeItem('expiredDate');
                createUpdateQuoteService.call(this, window.ibJS.createUpdateQuoteAPIPath, this.form, window.globalLanguage.sectionCriteriaKey, window.ibJS.quoteResultsPagePath);
            }
        } catch(e) {
            createUpdateQuoteService.call(this, window.ibJS.createUpdateQuoteAPIPath, this.form, window.globalLanguage.sectionCriteriaKey, window.ibJS.quoteResultsPagePath);
        }

        // Quote form modal listener - Age block
        this.$root.$on('set-quote-age', (obj, skip) => {
            if (!skip) this.form = Object.assign(this.form, obj);
            this.showAges = false;
        })
    },
    mounted: function () {
        if (window.ibJS && typeof window.ibJS.isResultsPage === 'undefined') {
            checkAgent.call(this, [false]);
        }
        //set Multiselect autocomplete and manuel select focus outline
        Array.prototype.forEach.call(document.getElementsByClassName('multiselect__input'), (x,i)=>{
            x.autocomplete="nope";
            x.addEventListener('focus',()=>{
                document.getElementsByClassName('multiselect__tags')[i].style.border = 0;
                this.multiselectFocus = true;
            });
            x.addEventListener('blur',()=>{
                document.getElementsByClassName('multiselect__tags')[i].style.border = '1px solid #e0e0e0';
                this.multiselectFocus = false;
            });
        });

        //Control multiselect tabbing
        const classSection = this.form.section === "j1Visa" ? ".quote-form-multiselect--lg" : ".quote-form-multiselect--sm";
        const multiSelectElm = document.querySelectorAll(classSection);
        for(let i = 0 ; i < multiSelectElm.length; i++){
            let el = multiSelectElm[i];
            if(el && el.classList.contains("multiselect--disabled") === false) {
                el.setAttribute("tabindex","0");
            }
        };

        this.$root.$on('full-quote-id', val => {
            if (val) {
                if (!this.selectedSchool) {
                    this.canNotFindSchoolName = true;
                }
            }
        })
    },
    methods: {
        createQuote: function (e) {
            e.preventDefault();

            if(!this.form.showNumChildren){
                this.form.numChildren10_17 = '';
                this.form.numChildrenUnder10 = '';
            }
            if(this.form.spouseAge == -1){
                this.form.spouseAge = null;
            }

            if(!this.form.showSpouseAge){
                this.form.spouseAge = null;
                this.form.spouseBday = '';
            }

            /*if(this.form.primaryAge < 18 && (this.form.spouseAge > 0 || this.form.numChildrenUnder10 > 0 || this.form.numChildren10_17 > 0)){
                this.$emit('nodependentscovered');
                return;
            }*/

            if(this.form.studyCountry === 'USA' && this.form.arrivalTime == '0' && this.form.section==='student'){
                this.form.physicalPresenceState = 'OutsideUSA';
            }

            if((this.form.section === 'opt' || this.form.section === 'j1Visa') && this.form.arrivalTime == '0'){
                this.form.physicalPresenceState = '';
            }

            if(this.form.section==='student'){
                if(this.form.arrivalTime == '9'){
                    this.form.homeCountry = 'USA';
                }
            }else if(this.form.section==='opt'){
                if(this.form.arrivalTime == '9'){
                    this.form.residenceCountry = '1';
                }else{
                    this.form.residenceCountry = '2';
                }
            }else if(this.form.section==='j1Visa'){
                if(this.form.activity=='1' && this.form.arrivalTime == '9'){
                    this.form.residenceCountry = '1';
                }else if(this.form.activity=='2' && this.form.arrivalTime >= '8'){
                    this.form.residenceCountry = '1';
                }else{
                    this.form.residenceCountry = '2';
                }
            }

            this.$v.$touch();

            if (!this.$v.$invalid && !this.calculateAges) {
                var data = JSON.stringify(this.form);
                createUpdateQuoteService.call(this, window.ibJS.createUpdateQuoteAPIPath, JSON.parse(data), window.globalLanguage.sectionCriteriaKey, window.ibJS.quoteResultsPagePath);
                this.$emit('close-edit-quote');
                
                if (ibJS.fullQuoteId) {
                    this.$http.post('/api/myaccount/remove-dup-quote/', {fullQuoteId: ibJS.fullQuoteId || ''});
                }
            }else{
                this.showMobileError = true;
            }
        },
        handleAgeInfoUpdate: function (ageInfo) {
            var person = ageInfo.person.toLowerCase();

            if(person === 'j1 visa holder' || person === 'f1 visa holder' || person === 'j2 visa holder' || person === 'f2 visa holder'){
                person = 'primary';
            }

            if (typeof ageInfo.age !== 'undefined') {
                this.form[person + 'Age'] = ageInfo.age;
            }
            if (typeof ageInfo.bday !== 'undefined') {
                this.form[person + 'Bday'] = ageInfo.bday;
            }
        },
        toggleAges: function () {
            this.showAges = true;
            this.showCoverageArea = false;
            this.showHomeCountry = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showArrivalInUSA = false;
            this.showStudyingIn = false;
            this.showStudyDestination = false;
            this.showVisaStatus = false;            
            this.agesOpened = true;
            this.$root.$emit('quote-modal', {
                showModal: true,
                startDate: this.form.startDate,
                validationStartDate: this.$v?.form?.startDate || null,
                form: this.form
            });
        },
        toggleCoverageArea: function () {
            this.showCoverageArea = !this.showCoverageArea;
            this.showAges = false;
            this.showHomeCountry = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showArrivalInUSA = false;
            this.showStudyingIn = false;
            this.showStudyDestination = false;
            this.showVisaStatus = false;  
            this.covAreaOpened = true;
        },
        toggleHomeCountry: function () {
            this.showHomeCountry = !this.showHomeCountry;
            this.showAges = false;
            this.showCoverageArea = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showArrivalInUSA = false;
            this.showStudyingIn = false;
            this.showStudyDestination = false;
            this.showVisaStatus = false;  
            this.homeCountryOpened = true;
        },
        toggleArrivalInUSA: function() {
            this.showArrivalInUSA = !this.showArrivalInUSA;
            this.showAges = false;
            this.showCoverageArea = false;
            this.showHomeCountry = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showStudyingIn = false;
            this.showStudyDestination = false;
            this.showVisaStatus = false;  
            this.arrivalInUSAOpened = true;
        },
        toggleLocation: function() {
            this.showLocation = !this.showLocation;
            this.showAges = false;
            this.showCoverageArea = false;
            this.showHomeCountry = false;
            this.showArrivalInUSA = false;
            this.showPriorInsurance = false;
            this.showStudyingIn = false;
            this.showStudyDestination = false;
            this.showVisaStatus = false;  
            this.locationOpened = true;
        },
        togglePriorInsurance: function() {
            if(this.form.arrivalTime > '3'){
                this.showPriorInsurance = !this.showPriorInsurance;
                this.showAges = false;
                this.showCoverageArea = false;
                this.showHomeCountry = false;
                this.showArrivalInUSA = false;
                this.showLocation = false;
                this.showStudyingIn = false;
                this.showStudyDestination = false;
                this.showVisaStatus = false;  
                this.priorInsuranceOpened = true;
            }
        },
        toggleStudyingIn: function() {
            this.showStudyingIn = !this.showStudyingIn;
            this.showAges = false;
            this.showCoverageArea = false;
            this.showHomeCountry = false;
            this.showArrivalInUSA = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showStudyDestination = false;
            this.showVisaStatus = false;  
            this.studyingInOpened = true;
        },
        toggleStudyDestination: function() {
            this.showStudyDestination = !this.showStudyDestination;
            this.showAges = false;
            this.showCoverageArea = false;
            this.showHomeCountry = false;
            this.showArrivalInUSA = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showVisaStatus = false;
        }, 
        toggleVisaStatus: function() {
            this.showVisaStatus = !this.showVisaStatus;
            this.showAges = false;
            this.showCoverageArea = false;
            this.showHomeCountry = false;
            this.showArrivalInUSA = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showStudyingIn = false;
            this.showStudyDestination = false;
            this.visaStatusOpened = true;
        },   
        toggleStudentName: function() {
            this.showVisaStatus = false;
            this.showAges = false;
            this.showCoverageArea = false;
            this.showHomeCountry = false;
            this.showArrivalInUSA = false;
            this.showLocation = false;
            this.showPriorInsurance = false;
            this.showStudyingIn = false;
            this.showStudyDestination = false;
        },   
        showModal: function (url) {
            this.$emit('show-modal', url);
        },
        resetForm: function(e){
            this.$emit('resubmit');
            this.showMobileError=false;
            this.form.primaryAge= null;
            this.form.primaryBday= '';
            this.form.spouseAge= null;
            this.form.spouseBday= '';
            this.form.numChildren10_17= '';
            this.form.numChildrenUnder10= '';
            this.form.startDate= '';
            this.form.endDate= '';
            this.form.policyMaximum= defs.policyMaximum || '';
            this.form.studyCountry= defs.studyCountry || '';
            this.form.homeCountry= defs.homeCountry || '',
            this.form.medicareAttest= false;
            this.form.citizenshipCountry= defs.citizenshipCountry || '';
            this.form.coverageArea= defs.coverageArea || '';
            this.form.arrivalInUSA= defs.arrivalInUSA || '';
            this.form.arrivalTime= defs.arrivalTime || '';
            this.form.mailingState= '';
            this.form.physicalPresenceState= '';
            this.form.visaStatus='';
            this.form.activity='1';
            this.form.medicalRequired='true';
            this.form.f1Insurance='-1';
            this.form.j1Insurance='-1';
            this.form.priorInsurance='-1';
            this.form.priorInsuranceExpiration='-1';
            this.form.section= window.globalLanguage.section || '';
            this.form.showSpouseAge=false;
            this.form.showNumChildren=false;
            this.agesOpened=false;
            this.covAreaOpened=false;
            this.homeCountryOpened=false;
            this.arrivalInUSAOpened=false;
            this.locationOpened=false;
            this.priorInsuranceOpened=false;
            this.studyingInOpened=false;
            this.homeCountryInfo=ibJS.homeCountryDefault;
            this.coverageAreaInfo=ibJS.coverageAreaDefault;
            this.locationInfo='';
            this.visaStatusInfo = '';
            this.priorInsuranceInfo=ibJS.priorInsuranceDefault;
            this.arrivalInUSAInfo=ibJS.arrivalInUSADefault;
            this.residenceCountryInfo=ibJS.residenceCountryDefault;
            this.form.residenceCountry='';
            this.showVisaStatus=false;
            this.visaStatusOpened=false;
            this.studyDestinationLabel="";
            this.form.schoolId = null;
            this.selectedSchool = null;
            this.canNotFindSchoolName = false;
            if(this.form.homeCountry) {
                this.locationInfo = $("#HomeCountry option[value='" + this.form.homeCountry + "']:first").text();
            }
            this.$root.$emit('reset-quote-modal');
            this.$v.$reset();
            e.preventDefault();
        },
        displayCoverage: function(e){
            var selectedIndex = e.target.options.selectedIndex;
            this.coverageAreaInfo = e.target.options[selectedIndex].text;
            this.$v.form.coverageArea.$touch();
        },
        displayHomeCountry: function(e){
            var selectedIndex = e.target.options.selectedIndex;
            this.homeCountryInfo = e.target.options[selectedIndex].text;
            this.$v.form.homeCountry.$touch();
        },
        displayResidenceCountry: function(e){
            this.selectedSchool = null;
            this.form.schoolId = null;
            var selectedIndex = e.target.options.selectedIndex;
            this.residenceCountryInfo = e.target.options[selectedIndex].value;
            if(this.residenceCountryInfo !== 'USA'){
                this.showVisaStatus = true;
            }else{
                this.showVisaStatus = false;
            }
            this.$v.form.studyCountry.$touch();            
        },
        displayPriorInsurance: function(e){
            var selectedIndex = e.target.options.selectedIndex;
            this.priorInsuranceInfo = e.target.options[selectedIndex].text;
            this.$v.form.priorInsurance.$touch();
        },
        displayLocation: function(e){
            var selectedIndex = e.target.options.selectedIndex;
            if(this.form.section === 'student') {
                this.locationInfo = e.target.options[selectedIndex].text;
            }
            else if(this.form.section === 'j1Visa') {
                this.mailingFullState = e.target.options[selectedIndex].text;
            }
            this.$v.form.mailingState.$touch();
        },
        displayPhysicalPresence: function(e) {
            var selectedIndex = e.target.options.selectedIndex;
            this.locationInfo = e.target.options[selectedIndex].text;
            this.$v.form.physicalPresenceState.$touch();
        },
        displayArrivalInUSA: function(e){
            var selectedIndex = e.target.options.selectedIndex;
            this.arrivalInUSAInfo = e.target.options[selectedIndex].text;
            this.$v.form.arrivalTime.$touch();
        },
        nameWithCityState: function ({
            value,
            city,
            state
        }) {
            return `${value} - ${city}, ${state}`;
        },
        resetAge: function () {
            this.form.primaryAge= null;
            this.form.primaryBday= '';
            this.form.spouseAge= null;
            this.form.spouseBday= '';
            this.form.numChildren10_17= '';
            this.form.numChildrenUnder10= '';
            this.form.showSpouseAge=false;
            this.form.showNumChildren=false;
            this.agesOpened=false;
        },
        getSchool: function(id) {
            let school = null;
            if(id) {
                this.$http.post('/school/search-school-by-id/', id).then((response) => {
                    if (response && response.body) {
                        this.selectedSchool = {
                            value: response.body.schoolName,
                            code: response.body.schoolId,
                            city: response.body.city,
                            state: response.body.state
                        };
                        this.form.schoolId = this.selectedSchool.code;
                        this.studyDestinationLabelFn();
                    }
                }, error => {
                    console.error(error);
                })
            } else {
                this.studyDestinationLabelFn();
            }
            return school;
        },
        asyncFind: function (query) {
            if (!this.triggerTimeout && query) {
                this.triggerTimeout = setTimeout(() => {
                    this.isLoading = true;
                    this.$http.post('/school/search-school-name-for-quotes/', query).then((res) => {
                        window.clearTimeout(this.triggerTimeout);
                        this.isLoading = false;
                        this.triggerTimeout = null;
                        const allSchools = res.body.data && res.body.data.data ? JSON.parse(res.body.data.data) : [];
                        const langCode = window.globalLanguage.lang === 'en' ? 1 : window.globalLanguage.lang === 'zh' ? 2 : window.globalLanguage.lang === 'es' ? 3 : 4;
                        if (allSchools.length) {
                            this.schoolNames = [...JSON.parse(res.body.data.data)].filter(item => item.langId == langCode);
                        } else {
                            this.schoolNames = [];
                            this.noNamesFound = true;
                        }
                    }).catch(err => {
                        window.clearTimeout(this.triggerTimeout);
                        this.isLoading = false;
                        this.triggerTimeout = null;
                        console.error("school fetch:", err)
                    });
                }, 250);
            }
        },
        onSelected() {
            document.querySelector('#dummyId')?.focus();
            Vue.nextTick(()=>{
                this.studyDestinationLabelFn();
            })
        },
        studyDestinationLabelFn: function () {
            let label = window.ibJS.studyDestinationDefault;
            let countrySelected = $('#StudyCountry option[value="' + this.form.studyCountry + '"]').html();
            Vue.nextTick(()=>{
                if (this.form.studyCountry && this.form.studyCountry != 'USA') {
                    label = countrySelected ? countrySelected.trim() : '';
                } else if (this.form.studyCountry === 'USA' && !this.form.schoolId) {
                    countrySelected = countrySelected ? countrySelected.trim() : '';
                    label = window.globalLanguage.lang != 'en' ? countrySelected : 'USA';
                } else if (this.form.studyCountry === 'USA' && this.selectedSchool) {
                    countrySelected = countrySelected ? countrySelected.trim() + ' - ' : '';
                    label = (window.globalLanguage.lang != 'en' ? countrySelected : 'USA - ') + this.selectedSchool.value + ' - ' + this.selectedSchool.city + ', ' + this.selectedSchool.state;
                }
                this.studyDestinationLabel = label;
            });
        }
    },
    computed:{
        displayAges: function(){
            var ageString = ibJS.editAgesText;
            if(this.form.primaryAge != null && this.form.primaryAge > 0){
                ageString = this.form.primaryAge;
                if(this.form.spouseAge != null && this.form.spouseAge > 0 && this.form.showSpouseAge){
                    ageString += ', ' + this.form.spouseAge + ' ' + ibJS.yearsText;
                }else{
                    ageString+= ' ' + ibJS.yearsText;
                }
            }else if(this.form.spouseAge != null && this.form.spouseAge > 0){
                ageString = this.form.spouseAge + ' ' + ibJS.yearsText;
            }

            if((this.form.primaryAge != null || this.form.spouseAge != null) && this.form.showNumChildren &&
                (this.form.numChildrenUnder10 > 0 || this.form.numChildren10_17 > 0)){

                const numChildren10_17 = this.form.numChildren10_17 != '' ? this.form.numChildren10_17 : 0;
                const numChildrenUnder10 = this.form.numChildrenUnder10 != '' ? this.form.numChildrenUnder10 : 0;
                
                var numChildren = parseInt(numChildren10_17,10) + parseInt(numChildrenUnder10,10);
                ageString += ', ' + numChildren + ' ' + ibJS.childrenText.toLowerCase();
            }

            return ageString;
        },
        calculateAges: function() {
            var isVisible = false,
                showSpouseAge = this.form.showSpouseAge,
                primaryAge = this.form.primaryAge,
                spouseAge = this.form.spouseAge;

            var showChildren = this.form.showNumChildren;

                this.spouseMinorAge = false;
                this.primaryMinorAge = false;
                this.priMinWithKid = false;
            if(this.form.visaStatus !== 'F2' && this.form.visaStatus !== 'J2' && showSpouseAge && primaryAge){
                if(primaryAge < 18){
                    isVisible = true;
                    this.primaryMinorAge = true;
                }
                else if(spouseAge && spouseAge !== -1 && spouseAge < 18 && !isVisible) {
                    this.primaryMinorAge = false;
                    isVisible = true;
                    this.spouseMinorAge = true;
                } else{
                    this.spouseMinorAge = false;
                }
            }
            if(showChildren && primaryAge){
                if(primaryAge < 18 && (this.form.numChildrenUnder10 > 0 || this.form.numChildren10_17 > 0)){
                    isVisible = true;
                    this.priMinWithKid = true;
                }else{
                    this.priMinWithKid = false;
                }
            }

            return isVisible;
        },
        showYetToArrive: function() {
            return !this.showLocation && this.form.arrivalTime == 0 && this.form.arrivalTime !== '' && this.form.section == 'j1Visa';
        },
        showLocationMailingState: function() {
            return !this.showLocation && !this.showYetToArrive && this.form.arrivalTime == 0 && this.form.arrivalTime !== '';
        }
    }
});
